// The fixed bubble-sheet form library. A quiz picks a preset item count; the app
// loads the matching static layout map from assets/layouts/{items}.json. The app
// never renders, measures, or generates sheet geometry — these maps are ground
// truth, distributed alongside the printed PDFs.
import type { LayoutMap } from './engine/types.js';
import { PRESETS, type Preset } from './db/schema.js';

export { PRESETS };
export type { Preset };

// Vite maps each preset JSON to a lazy importer (bundled + precached for offline).
const loaders = import.meta.glob('../assets/layouts/*.json');

const cache = new Map<Preset, LayoutMap>();

export async function loadLayout(items: Preset): Promise<LayoutMap> {
  const hit = cache.get(items);
  if (hit) return hit;
  const loader = loaders[`../assets/layouts/${items}.json`];
  if (!loader) throw new Error(`no bundled layout for preset ${items}`);
  const mod = (await loader()) as { default?: LayoutMap } & LayoutMap;
  const map = (mod.default ?? mod) as LayoutMap;
  cache.set(items, map);
  return map;
}
